import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, Button, FormItem } from 'vnetwork-ui'
import { useForm } from 'react-hook-form'

interface RegionSelectionModalProps {
    onSelectRegion: (region: string) => void
    onClose?: () => void
}

interface FormValues {
    region: string
}

const REGIONS = [
    { label: 'Taiwan', value: 'tw' },
    { label: 'China', value: 'cn' },
    { label: 'Singapore', value: 'sg' },
    { label: 'Japan', value: 'jp' },
    { label: 'Korea', value: 'kr' },
    { label: 'Hong Kong', value: 'hk' },
    { label: 'Thailand', value: 'th' },
    { label: 'Malaysia', value: 'my' },
    { label: 'Indonesia', value: 'id' },
    { label: 'Philippines', value: 'ph' },
]

const RegionSelectionModal: React.FC<RegionSelectionModalProps> = ({
    onSelectRegion,
    onClose,
}) => {
    const { t } = useTranslation()
    const [open, setOpen] = useState(true)

    const { control, handleSubmit, watch } = useForm<FormValues>({
        defaultValues: {
            region: '',
        },
    })

    const selectedRegion = watch('region')

    const onSubmit = (data: FormValues) => {
        if (data.region) {
            onSelectRegion(data.region)
            handleClose()
        }
    }

    const handleClose = () => {
        setOpen(false)
        onClose?.()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            title="Chọn vùng băng thông"
            maxWidth="sm"
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="p-4 space-y-4">
                    <div className="text-sm text-gray-600 mb-4">
                        Vui lòng chọn vùng băng thông để thêm vào cấu hình:
                    </div>

                    <FormItem
                        control={control}
                        name="region"
                        type="select"
                        label="Vùng băng thông"
                        placeholder="Chọn vùng băng thông"
                        options={REGIONS}
                    />

                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            type="button"
                        >
                            {t('cancel')}
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={!selectedRegion}
                        >
                            {t('confirm')}
                        </Button>
                    </div>
                </div>
            </form>
        </Dialog>
    )
}

export default RegionSelectionModal
